import React from "react";
import Spacer2 from "../Components/common/Spacer2";
import PageHeader from "../Components/common/PageHeader";
import { useTranslation } from "react-i18next";
import ProductSimilarsiviElSabunlari from "../Components/similar/ProductSimilarsiviElSabunlari";
import SEO from "../Components/common/SEO";

function ProductSimilarsiviElSabunlariPage() {
  const { t } = useTranslation();
  const siteUrl = 'https://seymenkimya.com';
  const pageUrl = `${siteUrl}/productsimilarsivielsabunlari`;

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Benzer Ürünler - Sıvı El Sabunları",
    "url": "https://seymenkimya.com/productsimilarsivielsabunlari",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@type": "Product",
            "name": "Sıvı El Sabunu",
            "url": "https://seymenkimya.com/sivielsabunu",
            "image": "https://seymenkimya.com/assets/images/product/sivielsabunu.webp"
          }
        },
        {
          "@type": "ListItem",
          "position": 2,
          "item": {
            "@type": "Product",
            "name": "Sıvı El Köpük",
            "url": "https://seymenkimya.com/sivielkopuk",
            "image": "https://seymenkimya.com/assets/images/product/sivielkopuk.webp"
          }
        },
        {
          "@type": "ListItem",
          "position": 3,
          "item": {
            "@type": "Product",
            "name": "Sıvı El Sabunu Mavi",
            "url": "https://seymenkimya.com/sivielsabunumavi",
            "image": "https://seymenkimya.com/assets/images/product/sivielsabunumavi.webp"
          }
        }
      ]
    }
  };

  return (
    <>
      <SEO
        title="Sıvı El Sabunları | Seymen Kimya"
        description="Nazik temizlik sağlayan sıvı el sabunu ve köpük seçeneklerini keşfedin."
        canonical={pageUrl}
        image={`${siteUrl}/assets/images/20-kg/15.webp`}
        structuredData={structuredData}
      />
      <PageHeader title={t("SIVI EL SABUNLARI")} />
      <Spacer2 />
      <ProductSimilarsiviElSabunlari />
    </>
  );
}

export default ProductSimilarsiviElSabunlariPage;
